import { Tag } from 'antd';
import { FormattedMessage } from 'react-intl';

import {
    dramaReviewStatusIntlId,
    getAuditStatus,
    resolveAdminReviewStatus,
    reviewStatusTagColor,
    statusIntlId,
    statusTagColor,
} from '@/pages/drama-review/utils';

import type { DramaItem } from '@/services/dramas';
import type { AuditStatusRecord } from '@/pages/drama-review/utils';

type AuditStatusCellProps = {
    /** 短剧带 review 时展示管理员审核状态；演员等仍走 status */
    record?: AuditStatusRecord & Pick<DramaItem, 'review'>;
};

const AuditStatusCell: React.FC<AuditStatusCellProps> = ({ record }) => {
    const adminReviewStatus = resolveAdminReviewStatus(record?.review);
    if (adminReviewStatus) {
        return (
            <Tag color={reviewStatusTagColor(adminReviewStatus)} style={{ marginInlineEnd: 0, whiteSpace: 'nowrap' }}>
                <FormattedMessage
                    id={dramaReviewStatusIntlId(adminReviewStatus)}
                    defaultMessage={adminReviewStatus}
                />
            </Tag>
        );
    }

    const status = getAuditStatus(record);
    return (
        <Tag color={statusTagColor(status)} style={{ marginInlineEnd: 0, whiteSpace: 'nowrap' }}>
            <FormattedMessage id={statusIntlId(status)} defaultMessage={status || '-'} />
        </Tag>
    );
};

export default AuditStatusCell;
